module.exports = __webpack_public_path__ + "static/media/xfactor.577a5381.jpg";